import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-evenly sm:justify-between items-center sm:flex-col lg:flex-row" }
const _hoisted_2 = { class: "text-right sm:text-center leading-tight" }
const _hoisted_3 = { class: "text-lg sm:text-base lg:text-lg text-gray-700" }
const _hoisted_4 = { class: "text-gray-600 text-xs sm:text-sm" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getIcon()), {
          class: ["w-20 sm:w-24 h-20 sm:h-24 mb-0 sm:mb-2 lg:mb-0", _ctx.color]
        }, null, 8, ["class"])),
        _createVNode("div", _hoisted_2, [
          _createVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createVNode("p", {
            class: ["text-3xl sm:text-2xl md:text-3xl lg:text-4xl font-header tracking-tight my-0 sm:mt-1 lg:my-0", _ctx.color]
          }, _toDisplayString(_ctx.amount), 3),
          _createVNode("p", _hoisted_4, " Monthly average " + _toDisplayString(_ctx.average), 1)
        ])
      ])
    ]),
    _: 1
  }))
}